/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(function() {

  $(document).on('click', '.box_product_infos h2', function(e) {
    const target = $(this).data('target');
    $('.box_product_infos .box_content').not($(target)).slideUp();
    $(target).slideToggle();
    $('.box_product_infos h2').not(this).find('.info_arrow').removeClass('open');
    $(this).find('.info_arrow').toggleClass('open');
  });

  function initProductGallerySplide() {
    var mainEl = document.getElementById('splide_main');
    var navEl = document.getElementById('splide_nav');

    if (!mainEl || !navEl) return;
    if (mainEl.classList.contains('is-initialized')) return;

   var thumbnails = new Splide(navEl, {
  type: 'slide',
  isNavigation: true,
  rewind: true,
  pagination: false,
  arrows: false,
  drag: true,
  gap: 10,
  fixedWidth: 88,
  fixedHeight: 110,
  focus: 0,
  trimSpace: false,
  updateOnMove: true,
  direction: 'ttb',
  height: 580,
  breakpoints: {
    1007: {
      direction: 'ltr',
      height: 'auto',
      fixedWidth: 72,
      fixedHeight: 90,
      gap: 8
    }
  }
});

    var main = new Splide(mainEl, {
      type: 'slide',
      rewind: true,
      pagination: false,
      arrows: false,
      drag: true,
      speed: 500,
      gap: 0,
      autoHeight: false,
      updateOnMove: true
    });

    main.sync(thumbnails);

    thumbnails.mount();
    main.mount();

    mainEl.classList.add('is-initialized');

    setTimeout(function() {
      main.refresh();
      thumbnails.refresh();
    }, 150);

    window.addEventListener('load', function() {
      main.refresh();
      thumbnails.refresh();
    });
  }

  initProductGallerySplide();

  const gnt_to_animate = document.querySelectorAll('.slideshow_badge');
  if (gnt_to_animate.length) {
    const gnt_observer = new IntersectionObserver(function(entries) {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('gnt_animate');
        } else {
          entry.target.classList.remove('gnt_animate');
        }
      }
    }, {
      rootMargin: '100px'
    });

    gnt_to_animate.forEach(function(element) {
      gnt_observer.observe(element);
    });
  }

});


